var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import { Drawer, Modal, Skeleton, useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { isFalsy } from '../../../utils/common';
import ScholarshipDetailsSection from './ScholarshipDetailsSection';
import SectionHeader from './SectionHeader';
import { COMPONENT_ID_ENUM } from './types';
import { scholarshipColumns } from './utils';
export var ScholarshipDetailsButton = function (_a) {
    var scholarshipData = _a.scholarshipData, onScholarshipModalOpen = _a.onScholarshipModalOpen;
    var _b = __read(useState(false), 2), expandScholarship = _b[0], setExpandScholarship = _b[1];
    var _c = __read(useState({}), 2), activeScholarShip = _c[0], setActiveScholarship = _c[1];
    var _d = __read(useState(false), 2), openModal = _d[0], setOpenModal = _d[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "secondary", onClick: function () {
                setActiveScholarship(scholarshipData);
                setExpandScholarship(true);
                onScholarshipModalOpen === null || onScholarshipModalOpen === void 0 ? void 0 : onScholarshipModalOpen();
            }, className: "lfc-hidden lg:lfc-block lfc-whitespace-nowrap lfc-min-w-fit" },
            React.createElement(GBTypography, { variant: "cta5" }, "Know More")),
        React.createElement(Button, { variant: "secondary", onClick: function () {
                setActiveScholarship(scholarshipData);
                setOpenModal(true);
                onScholarshipModalOpen === null || onScholarshipModalOpen === void 0 ? void 0 : onScholarshipModalOpen();
            }, className: "lfc-block lg:lfc-hidden lfc:whitespace-nowrap lfc-min-w-fit" },
            React.createElement(GBTypography, { variant: "cta5", className: "lfc-whitespace-nowrap lfc-min-w-fit" }, "Know More")),
        React.createElement(Modal, { open: openModal, onClose: function () {
                setOpenModal(false);
                setActiveScholarship({});
            } },
            React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-justify-between lfc-items-center" },
                React.createElement("div", { className: "lfc-w-[90%] lfc-h-[70%] lfc-bg-white lfc-mx-auto lfc-rounded-lg lfc-overflow-y-auto" },
                    React.createElement(ScholarshipDetailsSection, { onClose: function () {
                            setOpenModal(false);
                            setActiveScholarship({});
                        }, scholarshipData: activeScholarShip })))),
        React.createElement(Drawer, { anchor: "right", open: expandScholarship, onClose: function () {
                setExpandScholarship(false);
                setActiveScholarship({});
            }, className: "lfc-p-4", sx: {
                '& .MuiDrawer-paper': {
                    width: '40%'
                }
            } },
            React.createElement(ScholarshipDetailsSection, { onClose: function () {
                    setExpandScholarship(false);
                    setActiveScholarship({});
                }, scholarshipData: activeScholarShip }))));
};
var FinancialAidAndScholarshipSection = function (_a) {
    var scholarshipsData = _a.scholarshipsData, onScholarshipModalOpen = _a.onScholarshipModalOpen;
    var isBelowTablet = useMediaQuery('(max-width:768px)');
    if (isFalsy(scholarshipsData))
        return null;
    return (React.createElement("div", { className: "lfc-bg-white lfc-p-3 lg:lfc-p-4 lfc-rounded-lg lfc-w-full lfc-max-w-full", id: COMPONENT_ID_ENUM.COURSE_DETAILS_SCHOLARSHIP },
        React.createElement(SectionHeader, { title: "Financial Aid & Scholarships" }),
        React.createElement(DataGrid, { columns: scholarshipColumns(isBelowTablet, onScholarshipModalOpen), rows: scholarshipsData !== null && scholarshipsData !== void 0 ? scholarshipsData : [], getRowId: function (option) { return option === null || option === void 0 ? void 0 : option.scholarshipCode; }, autoHeight: true, getRowHeight: function () { return 'auto'; }, hideFooter: true, disableColumnFilter: true, disableColumnMenu: true, disableColumnSelector: true, hideFooterPagination: true, hideFooterSelectedRowCount: true, disableDensitySelector: true, density: "comfortable", disableRowSelectionOnClick: true, showColumnVerticalBorder: true, getRowClassName: function () { return 'hover:lfc-bg-white'; }, className: "hover:lfc-bg-transparent", sx: {
                '& .MuiDataGrid-cell:focus': {
                    outline: 'none',
                    background: 'none'
                },
                '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none'
                },
                '& .MuiDataGrid-columnHeader:focus': {
                    outline: 'none'
                },
                '& .MuiDataGrid-columnHeader:focus-within': {
                    outline: 'none'
                },
                '& .MuiDataGrid-columnSeparator': {
                    display: 'none'
                },
                '& .MuiDataGrid-columnHeader--filledGroup .MuiDataGrid-columnHeaderTitleContainer': {
                    border: '0px'
                },
                '& .MuiDataGrid-columnHeaders': {
                    borderBottom: '0px'
                }
            }, components: {
                NoRowsOverlay: function () { return null; },
                LoadingOverlay: function () { return (React.createElement("div", null, new Array(10).fill(0).map(function (_value, index) { return (React.createElement(Skeleton, { key: index, variant: "rectangular", sx: {
                        mb: '1rem',
                        height: '36px',
                        backgroundColor: '#ebebeb'
                    } })); }))); }
            }, style: {
                background: 'white',
                border: '1px solid #E2E2E8',
                height: 'auto'
            } })));
};
export default FinancialAidAndScholarshipSection;
//# sourceMappingURL=FinancialAidAndScholarshipSection.js.map